import { Component } from "vue-property-decorator";
import { Block } from '../../../helpers/components';
import BaseBlock from "@/blocks/base-block";
import { RegistrationForm } from '../../../components/registration-form/registration-form';

@Block() @Component({
	components: {
		RegistrationForm
	}
})
export class RegistrationFormModal extends BaseBlock {

	showFormReg(event: Event) {
		event.preventDefault();
		this.$modal.show('registration-form');
	}

	opened() {
		const trackModalOpen = (window as any).trackModalOpen;

		if (typeof trackModalOpen === "function") {
			trackModalOpen();
		}
	}

	mounted() {
		(window as any).showFormRegGlobal = (e: Event) => {
			if (!e) {
				e = window.event;
			}
			this.showFormReg(e);
		}
	}
}

export default RegistrationFormModal;
